<template>
  <div class="page">
    <div class="tit flex-jb-c" style="margin-top:0">
      <span>店铺信息</span>
      <div v-if="type == 2" class="back-btn" @click="$router.go(-1)">
        重新选择
      </div>
    </div>
    <div class="box">
      <van-cell-group>
        <van-field v-model="params.storeName" label="店铺名称" placeholder="请输入店铺名称" :disabled="true" />
        <van-field v-model="params.storeTradeArea" label="店铺地址" placeholder="点击选择" @click="showMap = true" :disabled="true" />
        <van-field v-model="params.fullAddress" label="门牌号" placeholder="请输入门牌号" :disabled="true" />
        <van-field
          readonly
          clickable
          label="经营类目"
          :value="storeProductName"
          placeholder="点击选择您的经营类目"
          :disabled="true"
        >
          <template #button>
            <van-icon name="arrow" />
          </template>
        </van-field>
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            value-key="name"
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
      </van-cell-group>
    </div>
    <div class="tit">
      <span>基本资料</span>
    </div>
    <div class="box" style="background:none">
      <van-cell-group style="background:none">
        <van-field class="line-field" :border="false" label-width="0" v-model="submitData.copartnerPhone" placeholder="请填写推荐人手机号码（选填）" />
        <van-field class="line-field" label-width="0" :border="false" v-model="submitData.userFullName" placeholder="我们怎么称呼您（必填）" />
        <van-field
          class="line-field"
          v-model="data.storePhone"
          style="margin-bottom: 0"
          center
          clearable
          label-width="0"
          placeholder="请输入手机号码"
          :border="false"
          readonly
        >
          <template #button>
            <div v-if="verifuShow" class="sms-code" @click="applyStoreSmsCode">
              发送验证码
            </div>
            <!-- <van-button v-if="verifuShow" size="small" color="#FFF3E5" style="color:#FD8B17" @click="applyStoreSmsCode" :plain="true"></van-button> -->
            <van-button v-else size="small" style="color:#FD8B17">{{count}} s</van-button>
          </template>
        </van-field>
        <div class="createStore"  @click="csStoreDialog = true">
          电话号码不对？<span style="color:#259CEB">点击直接入驻</span>
        </div>
        <van-field class="line-field" label-width="0" :border="false" v-model="smsCode" placeholder="请输入验证码" />
      </van-cell-group>
    </div>
    <div class="agreement-warp">
      <div class="tips" @click="toAgreement">
        响锣店群绝不会把您的信息泄露给第三方
      </div>
      <div class="agreement-oper">
        <van-checkbox icon-size="16px" checked-color="#FF9A32" v-model="agreementChecked" /><span style="margin-left: 5px">我已阅读《响锣店群商家合作协议》</span>
      </div>
    </div>
    <div v-if="submitShow" class="foot-btn" @click="onSubmit">
      提交
    </div>
    <!-- 弹框 -->
    <div class="mask" v-if="showKnow">
      <div class="know-mask" v-if="!redShow">
        <div class="pic">
          <img
            src="https://xl-bdq.oss-cn-shenzhen.aliyuncs.com/images/ssmall/0814zq_notebook1.png"
          />
        </div>
        <div class="mask-info">
          <div class="suc">店铺申请提交成功</div>
          <div class="wait">店铺审核通过后会以手机短信</div>
          <!-- <view class="wait gh">海量店铺运营干货</view> -->
          <div class="wait">方式通知您，敬请留意！</div>
          <!-- <view class="wait">{{wxCode}}</view>
          <view class="btn" @tap="copyWx">复制微信号</view> -->
          <!-- <view class="btn" @tap="iKnow">我知道了</view> -->
        </div>
      </div>
      <div class="red-mask" :class="redShow?'on':''">
        <div class="close" @click="$router.go(-1)"></div>
      </div>
    </div>
    <van-overlay :show="csStoreDialog" >
      <div class="dialog-wrap">
        <div class="cs-dialog">
          <img src="@/assets/images/common/qrCode.png"  class="img" alt="" />
          <div class="cs-sub">请长按识别，创建我的店铺</div>
          <div class="van-icon van-icon-cross dialog-close" @click="csStoreDialog = false"></div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>

import WxValidate from '@/util/WxValidate'

export default {
  data () {
    return {
      csStoreDialog: false,
      agreementChecked: true,
      params: {
        storeName: '',
        fullAddress: '',
        storeContactPhone: '',
        lat: '',
        lng: '',
        storeProductType: '',
        storeTradeArea: '',
        storeIcon: '123'
      },
      showPicker: false,
      columns: [],
      fileList: [],
      showMap: false,
      poiaddress: '',
      storeProductName: '',
      data: {
        storePhone: '',
        storeName: '',
        smsTemplateType: 'code',
        type: '2'
      },
      submitData: {
        id: '',
        copartnerPhone: '',
        userFullName: '',
        storePhone: ''
      },
      verifuShow: true,
      count: '',
      timer: null,
      smsCode: '',
      token: '',
      submitShow: true,
      type: 1,
      isSendCode: false,
      showKnow: false,
      redShow : false,
      isSmsCodeLoading: false
    }
  },
  async created () {
    this.type = this.$route.query.type
    await this.getUncertifiedStoreInfo(this.$route.query.id)
    await this.withChildren()
    this.initValidate()
    const that = this
    window.onresize = function(){
      if (document.body.scrollHeight < h) {
        that.submitShow = false
      }else{
        that.submitShow = true
      }
    }
  },
  methods: {
    toAgreement() {
      this.$router.push({
        path: '/store/agreement'
      })
    },
    async getUncertifiedStoreInfo(id) {
      const result = await this.$api.activity.getUncertifiedStoreInfo({ id })
      this.params = result.data
      this.params.fullAddress = this.params.storeDetailAddress
      this.data.storeName = this.params.storeName
      this.submitData.id = this.params.voteActivityUncertifiedStoreId
      this.data.storePhone = this.params.storeContactPhone
    },
    //表单验证
    initValidate() {
      let rules = {
        userFullName: {
          required: true,
          maxlength: 20
        },
        storePhone: {
          required:true,
          tel: true
        }
      }
      let message = {
        userFullName: {
          required: '请输入联系人名称',
          maxlength: '联系人名称不能超过20个字'
        },
        storePhone: {
          required: '请输入电话号码',
          tel: '联系电话格式'
        }
      }
      //实例化当前的验证规则和提示消息
      this.WxValidate = new WxValidate(rules, message);
    },
    applyStoreSmsCode () {
      if (this.isSmsCodeLoading){
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.data.storePhone)) {
        this.$toast('手机号码有误')
        return
      }
      this.isSmsCodeLoading = true
      const data = this.data
      const TIME_COUNT = 120
      this.$api.user.applyStoreSmsCode(data).then(res => {
        this.isSmsCodeLoading = false
        if (res.status === 0){
          this.$toast('验证码已发送')
          this.token = res.data
          this.count = TIME_COUNT
          this.verifuShow = false
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--
            } else {
              this.verifuShow = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
        else
        {
          this.$toast(res.details)
        }
      })
    },
    async onSubmit () {
      try {
        this.submitData.storePhone = this.data.storePhone
        if (!this.agreementChecked) {
          throw '请勾选合作协议'
        }
        if (!this.smsCode) {
          throw '验证码不能为空'
        }
        if (!this.WxValidate.checkForm(this.submitData)) {
          const error = this.WxValidate.errorList[0]
          throw error.msg
        }
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        })
        await this.checkUserSmsCode()
        await this.voteActivityStoreSettled()
        this.$toast.clear()
        this.showKnow = true;
        setTimeout(() => {
          this.redShow = true
        }, 2000)
        // this.$router.go(-1)
      } catch (error) {
        this.$toast.clear()
        this.$toast(error)
      }
      // await this.checkUserSmsCode()
      // console.log('11111')
      // await this.voteActivityStoreSettled()
    },
    async checkUserSmsCode () {
      const data = {
        smsCode: this.smsCode,
        mblNo: this.data.storePhone,
        token: this.token
      }
      const result = await this.$api.user.checkUserSmsCode(data)
      console.log(result.status !== 0)
      if (result.status === 1) {
        throw '请先发送验证码'
      }
      if (result.status !== 0) {
        throw result.details
      }
    },
    async voteActivityStoreSettled () {
      const result = await this.$api.activity.voteActivityStoreSettled(this.submitData)
      console.log(result.status !== 0)
      if (result.status !== 0) {
        throw result.details
      }
    },
    async withChildren () {
      const result = await this.$api.store.withChildren()
      this.columns = result.data
      this.columns.forEach(item => {
        if (item.id === this.params.storeProductTypeArray[0]) {
          this.storeProductName = item.name
        }
      })
    },
    onConfirm (e) {
      this.showPicker = false
      this.params.storeProductType = e.id
      this.storeProductName = e.name
    },
    afterRead (file) {
      file.status = 'uploading'
      file.message = '上传中...'
      setTimeout(() => {
        file.status = 'failed'
        file.message = '上传失败'
      }, 1000)
    }
  }
}
</script>
<style lang="less" scoped>

  @import "~@/assets/css/var.less";

  .page{
    box-sizing: border-box;
    padding-top: 20px;
    padding-bottom: 50px;
  }
  .flex-jb-c{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .back-btn{
    width: 83px;
    height: 24px;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    border-radius: 3px;
    font-size: 12px;
    color: #FF9A32;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
  }
  .agreement-warp{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tips{
      display: flex;
      justify-content: center;
      font-size: 11px;
      color: #FD8D18;
      margin-bottom: 7px;
    }
    .agreement-oper{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 11px;
      color: #9A9A9A;
    }
  }
  .tit{
    box-sizing: border-box;
    font-size: 12px;
    color: #9A9A9A;
    display: flex;
    padding-left: 31px;
    margin: 20px 0 10px;
  }
  .box{
    width: 92%;
    background: #FFFFFF;
    border-radius: 10px;
    margin: 0 auto;
  }
  .foot-btn{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 49px;
    background: #FF9A32;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    color: #FFFFFF;
  }
  .line-field{
    margin-bottom: 10px;
    border: none;
  }
  .sms-code{
    width: 101px;
    height: 40px;
    line-height: 40px;
    background: #FFF3E6;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-content: center;
    user-select: none; 
    font-size: 13px;
    color: #FD8C18;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 999;
    .red-mask{
      width: 375px;
      height: 460px;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0);
      background-image: url('https://xl-bdq.oss-cn-shenzhen.aliyuncs.com/images/ssmall/red_shop_bg.png');
      background-size: cover;
      transition: 500ms;
      .close{
        width: 52/2px;
        height: 52/2px;
        background-image: url("https://xl-bdq.oss-cn-shenzhen.aliyuncs.com/images/ssmall/red_close.png");
        background-size: cover;
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translate(-50%, 90px);
      }
      &.on{
        transform: translate(-50%, -50%) scale(1);
      }
    }
    .know-mask {
      width: 500/2px;
      height: 360/2px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
      border-radius: 40/2px;

      .pic {
        text-align: center;
        position: relative;
        top: -40/2px;
        img {
          width: 235/2px;
          height: 205/2px;
        }
      }

      .mask-info {
        text-align: center;
        position: relative;
        top: -40/2px;
        .suc {
          font-weight: bold;
          font-size: 32/2px;
          color: #333;
          margin-bottom: 20/2px;
          height: 31/2px;
        }
        .wait {
          font-size: 28/2px;
          color: #999;
          margin-bottom: 16/2px;
          height: 29/2px;
          &.gh{
            color: #F39B33;
            font-weight: bold;
          }
        }
        .btn {
          width: 242/2px;
          height: 90/2px;
          line-height: 90/2px;
          background: linear-gradient(
            0deg,
            rgba(240, 207, 140, 1) 0%,
            rgba(238, 203, 137, 1) 100%
          );
          box-shadow: 0px 10px 20px 0px rgba(240, 207, 140, 0.33);
          border-radius: 45/2px;
          color: #5f3d12;
          font-size: 32/2px;
          text-align: center;
          margin: 0 auto;
          margin-top: 42/2px;
        }
      }
    }
  }
  /deep/ .van-field--disabled .van-field__label {
    color: #646566;
  }
  /deep/ .van-field__control:disabled {
    color: #646566;
  }
  .createStore{
    display: flex;
    padding: 10px 0;
    justify-content: center;
    font-size: 12px;
    color: #9A9A9A;
  }
  .dialog-wrap{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;

    .dialog-close{
      position: absolute;
      right: 15px;
      top:15px;
      width: 23px;
      height: 23px;
      font-size: 23px;
      line-height: 23px;
      text-align: center;
      color: #CDCDCD;
    }

    .cs-dialog{
      background-color: #fff;
      border-radius: 5px;
      width: 275px;
      padding:  30px 0;
      position: relative;

      .cs-title{
        font-size: 16px;
        color: #333;
        text-align: center;
      }

      .img{
        height: 159px;
        width: 159px;
        display: block;
        margin: 17px auto 0 auto;
      }

      .cs-sub{
        font-size: 10px;
        color: #999;
        line-height: 1;
        padding-top: 10px;
        text-align: center;
      }
    }
    .post-dialog{
       &>.img{
         width: 275px;
         height: 374px;
         display: block;
       }
      &>.btn-close{
         width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 23px auto;
        .iconfont{
           font-size: 32px;
           color: #fff;
        }
      }
    }
  }

</style>
